import { getContactTickets } from 'services/pod';

import { createAsyncThunk } from '@reduxjs/toolkit';
import { IContactTickets } from 'services/pod/types';

interface IProps {
  crmId: number;
  contactId: number;
  psaTicketKind?: number;
}

export const ThunkGetContactTickets = createAsyncThunk<IContactTickets[], IProps>(
  'pod/getContactTickets',
  async ({ crmId, contactId }) => {
    const r = await getContactTickets(crmId, contactId);
    return r.data;
  },
);
